import { render, staticRenderFns } from "./ordercetak.vue?vue&type=template&id=8492ab30"
import script from "./ordercetak.vue?vue&type=script&lang=js"
export * from "./ordercetak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports